import React from "react";
import "@frameworks/web/stylesheets/components/Reports/RevampedReports/Generic/LoaderPopUp.scss";
import PANPassword from "../RebrandedReports/GenericComponents/PANPassword";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
const AifPdfDownloadBlock = (props) => {
    const device = DeviceContext();
    return (React.createElement("div", { className: "smallcase-popup-loader taCenter" },
        React.createElement("div", { className: `smallcase-popup-loader-head txt-midnight-blue  ${device && (device === null || device === void 0 ? void 0 : device.isDesktop)
                ? "DMSansMedium_18_500"
                : "DMSanBold_18_700"}` },
            props.headTitle,
            device && (device === null || device === void 0 ? void 0 : device.isDesktop) && (React.createElement("span", { className: "edel-icon-cross-bold-small hand_cursor", onClick: () => props === null || props === void 0 ? void 0 : props.closePopup() }))),
        React.createElement("div", { className: "smallcase-popup-loader-body" },
            React.createElement(PANPassword, { reportText: "Statement" }),
            React.createElement("div", { className: "hand_cursor bg-secondary-blue aifpdf-btn lh-140 flexCenter", onClick: () => {
                    props.onClick();
                } },
                React.createElement("div", { className: `txt_white lh-22px ${device && (device === null || device === void 0 ? void 0 : device.isDesktop)
                        ? "DMSansMedium_18_500"
                        : " DMSanM_14_500"} ` }, "Download AIF statement")))));
};
export default AifPdfDownloadBlock;
